import React from "react";
import "./MrPrint.css";
import numToWords from "num-to-words"
import { TRANSPORTER_NAME } from "../config/config";

// numToWords = require('num-to-words');

const delivery_on = {
  0: " ",
  1: "Without LR",
  2: "Due",
  3: "On letter pad",
  4: "Not applicable",
  5: "ccr",
};

const station_shorts = {
  Ahmedabad:"AHM",
  Narol:"NRL",
  ASLALI:"ASL",
  SARKHEJ:"SKJ",
  NADIAD:"NDD",
  Anand:"AND",
  VADODARA:"VDR",
  DASRATH:"DSR",
  BAJWA:"BJW",
  BHARUCH:"BRC",
  ANKLESHWAR:"ANK",
  KAMREJ:"KMJ",
  SURAT:"SRT",
  BARDOLI:"BDL",
  NAVSARI:"NVS",
  VAPI:"VPI",
  SILVASA:"SLV",
  DAMAN:"DMN",
  MEHSANA:"MHN",
  UNJHA:"UNJ",
  SIDHPUR:"SID",
  PALANPUR:"PLN",
  DEESA:"DES",
  PATAN:"PTN",
  BHUJ:"BUJ",
  GANDHIDHAM:"GDM",
  MORBI:"MRB",
  SURENDRANAGAR:"SRN",
  RAJKOT:"RJK",
  NAVAGAM:"NVG",
  JAMNAGAR:"JMN",
  Gondal:"GDL",
  JETPUR:"JTP",
  JUNAGADH:"JND",
  BHAVNAGAR:"BHV",
};

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, month, year].join("-");
}


class MrPrint extends React.Component {
  constructor(props) {
    super(props);
  }

  
  render() {
    var mr_date = String(formatDate(this.props.fields.input_date))
    return (
      <page>
      <div id="MR">
        <div id="mr_accounts_copy">
          <p id="company">{TRANSPORTER_NAME}</p>
          <div id="mr_details">
            <div id="mr_party_name">Party Name -{this.props.fields.party_name}</div>
            <div id="mr_date">Date {mr_date}</div>
            <div id="mr_no">Mr No {this.props.fields.mr_no}</div>
             <div id="mr_type">Type {this.props.fields.bilty_type}</div>
              <div id="mr_address"></div>
                         
          </div>
          <div id="mr_row2">
       
          <table id="mr_table">
            <thead>
              <tr id="mr_tr">
              <th id="mr_th_left_most">Booking stn</th>
                  <th id="mr_th">LR No</th>
                  <th id="mr_th">
                    Booking Date
                  </th>
                  <th id="mr_th">PKG</th>
                  <th id="mr_th">Details</th>
                  <th id="mr_th">Frieght</th>
                  <th id="mr_th_right_most">
                  Date
                  </th>
                  </tr>
                  </thead>
                  <tbody>
            {this.props.fields.bilty_ids.map((item,index) => (
              <tr key={`${item.station_from_name}-${index}`} id="mr_tr">
                <td id="mr_th_left_most">{station_shorts[ String(item.station_from_name)]}</td>
                <td id="mr_th">{item.bilty_no}</td>
                <td id="mr_th">
                  {String(formatDate(
                    item.bilty_date.slice(0, item.bilty_date.indexOf("T"))
                  ))}
                </td>
                <td id="mr_th">{item.no_of_package}</td>
                <td id="mr_th">{item.pay_type_name}</td>
                <td id="mr_th">{Number(item.total_amount)}</td>
                <td id="mr_th_right_most">
                {mr_date}

                </td>
              </tr>
            ))}
            </tbody>
              </table>
          </div>
          <div id="mr_row3">
            <div id="mr_col1">
               <div>Delivery on: {delivery_on[Number(this.props.fields.delivery_on)]}</div>
                  
              <div>
                <div>Details from: {JSON.parse(sessionStorage.getItem("branch_name"))[
                "branch_name"
              ].toUpperCase()}</div>
                <div>{}</div>
              </div>

                <div>
                <div>Cheque No: {this.props.fields.cheque_no}</div>
                <div></div>
              </div>
              <div>
                <div>Amount In Word</div>
               <div id="mr_rupee">{numToWords(Number( this.props.fields.total_amount))+ " only"}</div>
              </div>

            </div>
            <hr id="mr_row_hr"/>
            <div id="mr_col2">
              <div id="mr_cht_l">
                <div>Frieght</div>

                <div>Hamail</div>

                <div>Ser. Charge</div>

                <div>Damurrage</div>
                <div>Other Chrage</div>
                <div>Refund</div>
                <div>Total</div>

              </div>
              <hr id="mr_row_hr"/>

              <div id="mr_cht_r">
              

              <div>{this.props.fields.to_pay_amount == ""
                  ? 0
                  : this.props.fields.to_pay_amount}</div>

                <div> {this.props.fields.hamali == ""
                  ? 0
                  : this.props.fields.hamali}</div>

                <div>{this.props.fields.service_charge == ""
                  ? 0
                  : this.props.fields.service_charge}</div>

                <div>{this.props.fields.demarage_charge == ""
                  ? 0
                  : this.props.fields.demarage_charge}</div>

                <div> {this.props.fields.other_charge == ""
                  ? 0
                  : this.props.fields.other_charge}</div>

                  <div>{this.props.fields.refund == ""
                  ? 0
                  : "-" + this.props.fields.refund}</div>

                        <div>{Number(this.props.fields.to_pay_amount) +
                              Number(this.props.fields.hamali) +
                              Number(this.props.fields.service_charge) +
                              Number(this.props.fields.demarage_charge) +
                              Number(this.props.fields.other_charge) - Number(this.props.fields.refund)}</div>
              </div>
                    
              </div>

          </div>
          <div id="mr_row4">
           
            <div>{}</div>
            <div>{JSON.parse(sessionStorage.getItem("user_name"))[
              "user_name"
            ].toUpperCase()}</div>
           <div>ACCOUNT COPY</div>
            <div>{TRANSPORTER_NAME}</div> 
          </div>
        </div>
        <hr id="mr-hr"/>
        <div id="mr_party_copy">
          <p id="company">{TRANSPORTER_NAME}</p>
          <div id="mr_details">
            <div id="mr_party_name">Party Name -{this.props.fields.party_name}</div>
            <div id="mr_date">Date {mr_date}</div>
            <div id="mr_no">Mr No {this.props.fields.mr_no}</div>
             <div id="mr_type">Type {this.props.fields.bilty_type}</div>
              <div id="mr_address"></div>
                         
          </div>
          <div id="mr_row2">
          <table id="mr_table">
            <thead>
              <tr id="mr_tr">
              <th id="mr_th_left_most">Booking stn</th>
                  <th id="mr_th">LR No</th>
                  <th id="mr_th">
                    Booking Date
                  </th>
                  <th id="mr_th">PKG</th>
                  <th id="mr_th">Details</th>
                  <th id="mr_th">Frieght</th>
                  <th id="mr_th_right_most">
                  Date
                  </th>
                  </tr>
                  </thead>
                  <tbody>
            {this.props.fields.bilty_ids.map((item,index) => (
              <tr key={`${item.station_from_name}-${index}`} id="mr_tr">
                <td id="mr_th_left_most">{station_shorts[ String(item.station_from_name)]}</td>
                <td id="mr_th">{item.bilty_no}</td>
                <td id="mr_th">
                  {String(formatDate(
                    item.bilty_date.slice(0, item.bilty_date.indexOf("T"))
                  ))}
                </td>
                <td id="mr_th">{item.no_of_package}</td>
                <td id="mr_th">{item.pay_type_name}</td>
                <td id="mr_th">{Number(item.total_amount)}</td>
                <td id="mr_th_right_most">
                {mr_date}

                </td>
              </tr>
            ))}
            </tbody>
              </table>
          </div>
          <div id="mr_row3">
            <div id="mr_col1">
               <div>Delivery on: {delivery_on[Number(this.props.fields.delivery_on)]}</div>

              <div>
                <div>Details from: {JSON.parse(sessionStorage.getItem("branch_name"))[
                "branch_name"
              ].toUpperCase()}</div>
                <div>{}</div>
              </div>

                <div>
                <div>Cheque No: {this.props.fields.cheque_no}</div>
                <div></div>
              </div>
              <div>
                <div>Amount In Word</div>
               <div id="mr_rupee">{numToWords(Number( this.props.fields.total_amount))+ " only"}</div>
              </div>

            </div>
            <hr id="mr_row_hr"/>
            <div id="mr_col2">
            
            <div id="mr_cht_l">
                <div>Frieght</div>

                <div>Hamail</div>

                <div>Ser. Charge</div>

                <div>Damurrage</div>
                <div>Other Chrage</div>
                <div>Refund</div>
                <div>Total</div>

              </div>
              <hr id="mr_row_hr"/>

      <div id="mr_cht_r">
              <div>{this.props.fields.to_pay_amount == ""
                  ? 0
                  : this.props.fields.to_pay_amount}</div>

                <div> {this.props.fields.hamali == ""
                  ? 0
                  : this.props.fields.hamali}</div>

                <div>{this.props.fields.service_charge == ""
                  ? 0
                  : this.props.fields.service_charge}</div>

                <div>{this.props.fields.demarage_charge == ""
                  ? 0
                  : this.props.fields.demarage_charge}</div>

                <div> {this.props.fields.other_charge == ""
                  ? 0
                  : this.props.fields.other_charge}</div>

                <div>{this.props.fields.refund == ""
                  ? 0
                  : "-" + this.props.fields.refund}</div>
            
                <div>{Number(this.props.fields.to_pay_amount) +
                      Number(this.props.fields.hamali) +
                      Number(this.props.fields.service_charge) +
                      Number(this.props.fields.demarage_charge) +
                      Number(this.props.fields.other_charge) - Number(this.props.fields.refund)}</div>

                
              </div>
                    </div>

            
          </div>
          <div id="mr_row4">
           
            <div>{}</div>
            <div>{JSON.parse(sessionStorage.getItem("user_name"))[
              "user_name"
            ].toUpperCase()}</div>
           <div>PARTY COPY</div>
            <div>{TRANSPORTER_NAME}</div>
          </div>
        </div>
      </div>{" "}
    </page>
    );
  }
}

export default MrPrint;
